import { ReactNode } from 'react';

import { Constants } from '@constants';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { FormattedMessage } from 'react-intl';

import { TFormData } from './ApplyFlexiLoanFormView';

// eslint-disable-next-line import/no-default-export
export default (values: TFormData) => {
    const errors: {
        [k in keyof TFormData]?: ReactNode;
    } = {};

    if (!values.turnover) {
        errors.turnover = (
            <FormattedMessage
                id="_.apply_flexi_loan.turnover.validation"
                defaultMessage="Please enter your turnover of the last 12 months"
            />
        );
    }

    if (!values.amount) {
        errors.amount = (
            <FormattedMessage
                id="_.apply_flexi_loan.requestedAmount.validation.missing"
                defaultMessage="Please enter an amount"
            />
        );
    }

    if (values.amount < Constants.MIN_LOAN_AMOUNT) {
        errors.amount = (
            <FormattedMessage
                id="_.apply_flexi_loan.requestedAmount.validation.tooLow"
                defaultMessage="Please enter an amount greater than {minAmount, number, :: currency/GBP precision-integer}"
                values={{
                    minAmount: Constants.MIN_LOAN_AMOUNT
                }}
            />
        );
    }
    if (values.amount > Constants.MAX_LOAN_AMOUNT) {
        errors.amount = (
            <FormattedMessage
                id="_.apply_flexi_loan.requestedAmount.validation.tooHigh"
                defaultMessage="Please enter an amount less than {maxAmount, number, :: currency/GBP precision-integer}"
                values={{
                    maxAmount: Constants.MAX_LOAN_AMOUNT
                }}
            />
        );
    }

    if (!values.purpose) {
        errors.purpose = (
            <FormattedMessage
                id="_.apply_flexi_loan.loanPurpose.validation"
                defaultMessage="Please select a purpose for the funds"
            />
        );
    }

    if (getCountry() === 'DE' && !values.duration) {
        errors.duration = (
            <FormattedMessage
                id="_.apply_flexi_loan.loanDuration.validation"
                defaultMessage="Bitte wählen Sie eine Laufzeit aus"
            />
        );
    }

    return errors;
};
